import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

type HeaderProps = {
	value: string;
};

export const Header = ({ value }: HeaderProps) => {
	const { $t } = useIntl();

	return (
		<>
			<S.PageTitle>{$t('codeVerification.title')}</S.PageTitle>
			<S.Disclaimer>
				{$t('auth.welcome.codeInput.sentTo', {
					medium: <S.Medium>{value}</S.Medium>
				})}
			</S.Disclaimer>
		</>
	);
};

namespace S {
	export const PageTitle = styled.label`
		display: block;
		${({ theme }) => theme.fonts.headings.title6};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const Disclaimer = styled.label`
		display: inline-block;
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin: ${({ theme }) => theme.spacings.xxxsmall} 0 ${({ theme }) => theme.spacings.xlarge};
	`;

	export const Medium = styled.span`
		${({ theme }) => theme.fonts.text.text1};
	`;
}
